import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AccionAnualModel, AreasAnualesModel, EstrategiasAreasModel } from 'src/app/model/FaseAnual.model';
import { UnidadEducativaModel } from 'src/app/model/Identificacion.model';
import { JardinModel } from 'src/app/model/Jardin.model';
import { apiService } from 'src/app/service/api.service';
import { PlanMejoraService } from 'src/app/service/planMejora.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-estrategia-anual',
  templateUrl: './estrategia-anual.component.html',
  styleUrls: ['./estrategia-anual.component.css']
})
export class EstrategiaAnualComponent implements OnInit {

  @ViewChild('divSpinner') divSpinner:ElementRef;

  @Input() estrategiaData : EstrategiasAreasModel;
  @Input() areaNumber : number;
  @Input() readonly : boolean;

  dataJardin : JardinModel;
  
  cargando: boolean;
  uniEducativa = new UnidadEducativaModel();

  constructor(
    private planMejoraService: PlanMejoraService,
    private api: apiService,
  ) {}

  ngOnInit(): void {     
    this.cargando = true;
    this.cargaInicial();
  }

  cargaInicial(){ 
    this.dataJardin = this.api.dataJardin;
  }

  addNuevaAccion(acciones): void {
    acciones.push(new AccionAnualModel());
  }

  borrarAccion(acciones, indice): void {
    Swal.fire({
      title: '¿Está seguro que desea borrar la Acción?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        if (acciones.length >1 && (acciones[indice].idAccion !=-1 && acciones[indice].idAccion !=null)) {
          this.borrarAccionBD(acciones[indice]);
          acciones.splice(indice, 1);
        } else {
          acciones.splice(indice, 1);
        }
        Swal.fire({
          title: '¡Acción borrada!',
          icon: 'info',
          confirmButtonText: 'OK'
        })
      }
    });
}

borrarAccionBD( accion : AccionAnualModel){
  this.planMejoraService.API_POST_borrarAccionesFaseAnual(this.dataJardin.id,accion.idAccion).subscribe((response:any) => {
  },
  (err) => {
    console.log(err)
  });
}

}
